import partnerLogo1 from '../../../assets/images/about/partners/partner1.svg';
import partnerLogo2 from '../../../assets/images/about/partners/partner2.svg';
import partnerLogo3 from '../../../assets/images/about/partners/partner3.svg';
export const PARTNERS_ABOUT_LABELS = {
	title: 'About Our Partners',
	partner1: {
		titleLinkLabel: 'MarketReady',
		titleLinkContent: 'https://marketreadyinsights.com/',
		content:
			'MarketReady Insights simplifies compliance for CPG brands with expert regulatory guidance. The MarketReady Verified seal highlights products reviewed for FDA labeling compliance and New Hope’s ingredient standards—helping transparent, compliant brands stand out and reach shelves faster. Learn more ',
		contentLinkLabel: 'here',
		contentLinkContent: 'https://marketreadyinsights.com/marketready-verified/',
		image: partnerLogo1
	},
	partner2: {
		titleLinkLabel: 'SPINS',
		titleLinkContent: 'https://www.spins.com/',
		content:
			'SPINS is a leading source of data and insights for the natural and organic industry. Through its partnership with Beacon Discovery, SPINS powers robust filtering—making it easy to search 20,000+ products by certifications, categories, and more. This data also helps brands and retailers uncover trends, track performance, and make smarter decisions.',
		image: partnerLogo2
	},
	partner3: {
		titleLinkLabel: 'HowGood',
		titleLinkContent: 'https://www.howgood.com/beacon-sustainability-data-portal',
		content:
			'HowGood is the world’s largest database for food product sustainability, offering insights into environmental and social impact. On Beacon Discovery, retailers can view sustainability estimates, filter for ESG-focused brands, and identify those working to reduce emissions. HowGood’s data supports transparency, regulatory reporting, and smarter sourcing decisions.',
		image: partnerLogo3
	}
};
